const vi = {
    "success": "Thành công",
    "failure": "Thất bại",
    "project": "Dự án",
    "status": "Trạng thái",
    "start_at": "Thời gian bắt đầu",
    "end_at": "Thời gian kết thúc",
    "assignees": "Phân công cho",
    "priority": "Mức ưu tiên",
    "progress": "Tiến độ",
    "estimated_time": "Thời gian ước lượng",
    "confirm_password_does_not_match": "Xác nhận mật khẩu không khớp",
    "password_invalid": "Mật khẩu không cho phép chưa khoảng trắng!",
    "confirm": "Xác nhận",
    "cancel": "Hủy",
    "has_error": "Có lỗi!",
    "transfer_work": "Điều chuyển công việc",
    "are_you_sure_you_want_to_move_this_task_from_project": "Bạn chắn chắn muốn điều chuyển công việc này từ",
    "to_project": "đến dự án",
    "view_detail": "Xem chi tiết",
    "effort": "Hiệu suất",
    "score":"Điểm",
    "result":'Kết quả',
    "comment": 'Ghi chú',
    "name_evaluation":"Tên bảng đánh giá",
    "date": "Ngày",
    "notes_cannot_be_empty": "Nội dung ghi chú không được để trống",
    "confirm_deletion_timekeeping": "Bạn chắc chắn muốn xóa chấm công này?",
    "time_checkin": "Thời gian checkin",
    "time_checkout": "Thời gian checkout",
    "not_check": "Not check",
    "working_time": "Số giờ công",
    "time_in":"In ",
    "time_out":"Out ",
    "remaining_leave_hours": "Số giờ phép",
    "delete_timekeeping": "Xóa chấm công!",
    "delete_timekeeping_success": "Đã xóa bản chấm công",
    "start" : "Bắt đầu",
    "finish" : "Kết thúc",
    "start_task" : "Bắt đầu công việc",
    "finish_task" : "Kết thúc công việc",
    "category": "Thể loại",
    "item": "Tiểu mục",
    "description": "Mô tả",
    "select_members":"Chọn một hoặc nhiều thành viên",
    "error_position":"Vui lòng chọn chức vụ",
    "error_member":"Vui lòng chọn thành viên",
    'january': 'Tháng 1',
    'february': 'Tháng 2',
    'march': 'Tháng 3',
    'april': 'Tháng 4',
    'may': 'Tháng 5',
    'june': 'Tháng 6',
    'july': 'Tháng 7',
    'august': 'Tháng 8',
    'september': 'Tháng 9',
    'october': 'Tháng 10',
    'november': 'Tháng 11',
    'december': 'Tháng 12',

    'Su': 'CN',
    'Mo': 'T2',
    'Tu': 'T3',
    'We': 'T4',
    'Th': 'T5',
    'Fr': 'T6',
    'Sa': 'T7',

    "jsgantt": {
        'january': 'Tháng 1',
        'february': 'Tháng 2',
        'march': 'Tháng 3',
        'april': 'Tháng 4',
        'maylong': 'Tháng 5',
        'june': 'Tháng 6',
        'july': 'Tháng 7',
        'august': 'Tháng 8',
        'september': 'Tháng 9',
        'october': 'Tháng 10',
        'november': 'Tháng 11',
        'december': 'Tháng 12',

        'jan': 'Th 1',
        'feb': 'Th 2',
        'mar': 'Th 3',
        'apr': 'Th 4',
        'may': 'Th 5',
        'jun': 'Th 6',
        'jul': 'Th 7',
        'aug': 'Th 8',
        'sep': 'Th 9',
        'oct': 'Th 10',
        'nov': 'Th 11',
        'dec': 'Th 12',

        'Sunday': 'Chủ nhật',
        'Monday': 'Thứ Hai',
        'Tuesday': 'Thứ Ba',
        'Wednesday': 'Thứ Tư',
        'Thursday': 'Thứ Năm',
        'Friday': 'Thứ Sáu',
        'Saturday': 'Thứ Bảy',

        'Sun': 'CN',
        'Mon': 'T2',
        'Tue': 'T3',
        'Wed': 'T4',
        'Thu': 'T5',
        'Fri': 'T6',
        'Sat': 'T7',

        'resource': 'Người đảm nhiệm',
        'duration': 'Thời hạn',
        'comp': 'Tiến độ (%)',
        'completion': 'Tiến độ',
        'startdate': 'Ngày bắt đầu',
        'enddate': 'Ngày kết thúc',
        'moreinfo': 'Thông tin thêm',
        'notes': 'Ghi chú',
        'format': 'Chế độ',

        'hour': 'Giờ',
        'day': 'Ngày',
        'week': 'Tuần',
        'month': 'Tháng',
        'quarter': 'Quý',

        'hours': 'Giờ',
        'days': 'Ngày',
        'weeks': 'Tuần',
        'months': 'Tháng',
        'quarters': 'Quý',

        'hr': 'giờ',
        'dy': 'ngày',
        'wk': 'tuần',
        'mth': 'tháng',
        'qtr': 'Quý ',

        'hrs': 'giờ',
        'dys': 'ngày',
        'wks': 'tuần',
        'mths': 'tháng',
        'qtrs': 'quý',

        'tooltipTemplate': 'Đang tải...',
    },
    //Calendar
    'Th 2' : 'Thứ 2',
    'Th 3' : 'Thứ 3',
    'Th 4' : 'Thứ 4',
    'Th 5' : 'Thứ 5',
    'Th 6' : 'Thứ 6',
    'Th 7' : 'Thứ 7',
    'location' : 'Địa điểm',
    'create_event' : 'Thêm mới cuộc họp',
    'edit_event' : 'Chỉnh sửa cuộc họp',
    'detail_event' : 'Chi tiết cuộc họp',
    'save' : 'Lưu',
    'return' : 'Quay lại',
    'delete' : 'Xóa',
    'delete_event' : 'Xóa lịch họp',
    'edit' : 'Chỉnh sửa',
    'created_by': 'Người tạo',

    // Timekeeping management
    "file_content_invalid" : "Nội dung tệp không đúng định dạng",
    "require_timekeeping_file_format" : "Vui lòng chọn tệp có định dạng .csv hoặc .txt",

    // Evaluation Result
    "subsection" : "Tiểu mục",
    "evaluators" : "Nhân viên đánh giá",
    'required': ' không được phép để trống',
    'max_255': ' có không quá 255 ký tự',
    "unique" : ' đã được sử dụng',
    "confirm_redirect": "Bạn có muốn lưu lại những thay đổi này?",
    "yes":"Có",
    "no": "Không",
    "confirm_exit": "Các thay đổi bạn đã thực hiện có thể không được lưu. Bạn có muốn thoát không?",
    'evaluatee_placeholder': 'Chọn người được đánh giá',
    'evaluator_placeholder': 'Chọn người đánh giá',
    // Evaluation template
    'evaluatee_placeholder': 'Chọn người được đánh giá',
    'evaluator_placeholder': 'Chọn người đánh giá',
    "confirm_copy_evaluation": 'Bạn có muốn sao chép bản đánh giá này không?',
    "confirm_copy_template": 'Bạn có chắc muốn sao chép bản đánh giá mẫu này không?',
    'position_edit_succeed' : 'Chỉnh sửa chức vụ thành công',
    'resource_edit_succeed' : 'Chỉnh sửa tài nguyên thành công',
    'error_order_time': 'Vui lòng nhập giờ chốt đơn',
    'error_menu': 'Vui lòng nhập thực đơn hoặc lựa chọn',
    "confirm_copy_evaluation": 'Bạn có muốn sao chép bản đánh giá này không?',
    // Order
    'delete_order' : 'Xóa đơn',
    'confirm_deletion_order' : 'Bạn có chắc chắn muốn xóa đơn đặt cơm này?',
    'required_comment' : 'Vui lòng nhập ghi chú',
    'select_required': 'Vui lòng chọn :attribute!',
    'Please_choose_a_dish' : 'Vui lòng chọn món!',
    'Please_enter_the_dish' : 'Vui lòng nhập tên món!',
    'Please_enter_employee_name':'Vui lòng nhập tên nhân viên!',
    'please_enter_option': 'Vui Lòng nhập Lựa chọn',
    'employee_exist':'Nhân viên đã Order rồi',
    'Please_choose_month' : 'Vui lòng chọn tháng và năm',
    'Date_format_error' : 'Vui lòng chọn đúng định dang MM/YYYY',
    'Error_maxlength_option':'Vui Lòng nhập độ dài không quá 1000 ký tự',
    // Validate form create, edit task
    'please_enter_estimated_time' : 'Vui lòng nhập thời gian ước lượng!',
    'please_enter_title_task' : 'Vui lòng nhập tiêu đề công việc!',
    'please_enter_project' : 'Vui lòng chọn dự án!',
    'please_enter_type' : 'Vui lòng chọn phân loại!',
    'please_enter_status' : 'Vui lòng chọn trạng thái!',
    'please_enter_priority' : 'Vui lòng chọn mức độ ưu tiên!',
    'please_enter_function_screen' : 'Vui lòng nhập chức năng/màn hình!',
    'please_enter_bug_classify' : 'Vui lòng chọn phân loại bug!',
    'please_enter_bug_reason' : 'Vui lòng chọn phân loại nguyên nhân!',
    'please_enter_bug_range' : 'Vui lòng chọn phân loại phạm vi!',
    'please_enter_bug_severity' : 'Vui lòng chọn mức độ nghiêm trọng!',
    'please_enter_reason' : 'Vui lòng nhập nguyên nhân!',
    'please_enter_fix' : 'Vui lòng nhập cách sửa!',
    'please_enter_range' : 'Vui lòng nhập phạm vi ảnh hưởng!',
    // Request
    'please_enter_bta' : 'Vui lòng nhập BTA',
    'Error_max_bta' : 'Vui lòng nhập dưới 900.000.000',
    'before_or_equal' : 'Vui lòng nhập :attribute trước hoặc cùng :date!',
    'after_or_equal' : 'Vui lòng nhập :attribute cùng hoặc sau :date!',

    // Holiday List
    'please_enter_name_holiday': "Vui lòng nhập tên ngày nghỉ!",
    'please_enter_choose_holidays': "Vui lòng chọn ngày nghỉ!",

    'vacation': 'Nghỉ phép',

    'max_name_property_type': 'Vui lòng nhập Đầu mã tài sản không quá 50 kí tự!',
    // Task of the day
    'task': 'Công việc',

    // Asset
    // "max_length": "Vui lòng nhập :attribute bé hơn hoặc bằng :max",
    "not_in": "Trường :attribute đã chọn không hợp lệ",
    'asset_name': 'Tên tài sản',
    'name_in_contract': 'Tên tài sản (theo hợp đồng)',
    "name_short": "Tên tài sản rút gọn",
    "management_unit_id": "Đơn vị quản lý tài sản",
    "type_id": "Loại tài sản",
    "department_id" : "Đơn vị sử dụng",
    "user_use_asset": "Người sử dụng",
    'asset_code': 'Mã tài sản',
    "handover_record_code": "Mã số biên bản bàn giao",
    "seri_number": "Số serial",
    "supplier": "Nhà cung cấp",
    "manufacturer": "Hãng sản xuất",
    "manufacturing_date": "Ngày sản xuất",
    "asset_category": "Chủng loại",
    "usage_date": "Ngày sử dụng",
    "purchase_date": "Ngày mua",
    "condition_id": "Tình trạng",
    "pemises": "Cơ sở",
    "source_of_origin": "Nguồn hình thành",
    "asset_location": "Vị trí",
    "asset_description": "Mô tả",
    "residual_value" : "Giá trị còn lại",
    "original_price" : "Nguyên giá",
    "premises": "Cơ sở",
    "country_of_manufacture": "Nước sản xuất",

    // property
    'please_enter_name_property_management' : 'Vui lòng nhập tên đơn vị!',
    'max_name_property_management': 'Vui lòng nhập Tên đơn vị không quá 200 kí tự!',
    //department
    "department": "Tên phòng ban",
    "department_code": "Mã phòng ban",
    //property type
    "please_enter_name": "Vui lòng nhập :attribute!",
    "property_type_name": "Tên loại tài sản" ,
    "property_type_code": "Đầu mã tài sản",
    'property_status_name': 'Tên tình trạng tài sản',
    "max_length": "Vui lòng nhập :attribute không quá :max kí tự!",
    "property_agency_name": "Tên đơn vị",
    'max_file' : 'Vui lòng chọn :attribute có dung lượng tối đa :max MB!',
    'mimes_file' : 'Vui lòng chọn :attribute là file với định dạng: :values!',
    "asset_image" : "Hình ảnh",
    "asset_file": "Tệp đính kèm",
    "asset_note": "Ghi chú",
    "asset_branch": "Cơ sở",
    "asset_resource": "Nguồn hình thành",
    "asset_bidding_package_name": "Tên gói thầu",
    "asset_bidding_package_code": "Mã gói thầu",
    "add_task": "Tạo công việc",
    "enter_task_name": "Nhập tiêu đề công việc",
    "close" : "Đóng",
    //Customer
    "customer_name": "tên khách hàng",
    // evaluation
    "evaluation_template": "Mẫu đánh giá",
    "evaluator": "Người đánh giá",
    "evaluatee": "Người được đánh giá",
    "evaluation_finalizer": "Người chốt đánh giá",
    "evaluation_form_name": "Tên bản đánh giá",
    "considering_the_time_period": "Xét trong khoảng thời gian",
    "evaluation_deadline": "Hạn nộp đánh giá",
    "apply_for": "Người được đánh giá",
    "evaluation_type": "Loại đánh giá",
    "evaluatee_duplicate": "Người được đánh giá không được trùng nhau.",
    "evaluator_duplicate": "Người đánh giá không được trùng nhau.",
    "invalid_date_range": "Vui lòng nhập đúng định dạng ngày (dd/mm/yyyy - dd/mm/yyyy)",
    "evaluation_deadline_after_considering_the_time_period": "Vui lòng nhập hạn nộp đánh giá bằng hoặc sau thời gian đánh giá.",
    "deadline_must_be_after_evaluation_time": "Không thể chọn lại ngày bắt đầu hạn nộp đánh giá trong thời gian đánh giá.",
    "add": "Thêm",
    "remove": "Xóa",
    "actual_time": "Thời gian thực tế",
    'min_numeric': "Vui lòng nhập :attribute lớn hơn hoặc bằng :min!",
    //work schedule collaborator
    "max_shifts": "Tối đa 5 ca làm việc",

    //Vacation validation messages
    "vacation_block_two_hours": "Số giờ nghỉ phép phải là bội số của 2.",
    "vacation_working_hours": "Thời gian nghỉ phải nằm trong giờ làm việc của bạn.",
    "vacation_time_order": "Số giờ nghỉ phép phải khác 0.",
    // Checklist
    "performer": "Người thực hiện"
};
export default vi;



// WEBPACK FOOTER //
// ./resources/build/js/locales/vi.js